import React from 'react';
import { Divider } from 'antd';
import PropTypes from 'prop-types';
import {
  ShowIf,
} from '../components';

function CustomAction({component, iteration, length, showDividerAlways}) {
  const buttonTextStyleNormal = { color: '#898989', padding: '4px 16px', height: '100%' };
  return (
    <div style={buttonTextStyleNormal}>
      {component}
      <ShowIf condition={showDividerAlways || iteration < length - 1}>
        <Divider type="vertical" style={{ height: '34px', margin: 0 }} />
      </ShowIf>
    </div>
  );
}
CustomAction.propTypes = {

};
CustomAction.defaultProps = {

};
export default CustomAction;
